"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSchoolValues = void 0;
exports.defaultSchoolValues = {
    schoolId: undefined,
    name: undefined,
    region: undefined,
    urn: undefined,
    localAuthority: undefined,
    town: undefined,
    postcode: undefined,
    minorGroup: undefined,
    primary: undefined,
    secondary: undefined,
    post16: undefined,
    minAge: undefined,
    maxAge: undefined,
    gender: undefined,
    groupType: undefined,
    groupName: undefined,
    numberOfStudents: undefined,
    internationalSchool: undefined,
    mat: undefined,
    type: undefined,
    schoolSize: undefined,
    privateSchool: undefined
};
//# sourceMappingURL=common.js.map